module.exports = {template: '<svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 5.134L4.866 9l7.057-7.057L10.98 1 4.866 7.115 1.994 4.242 1 5.134z" fill="#2CEEA8" stroke="#2CEEA8"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/check.svg
// module id = 143
// module chunks = 1